"use client";

import { useTranslations } from "next-intl";

import { Checkbox } from "@louez/ui";

type OptionalLine = {
  code: string;
  description: string;
};

type QuoteOptionalLinesProps = {
  enabledCodes: string[];
  lines: OptionalLine[];
  onChange: (codes: string[]) => void;
};

export const QuoteOptionalLines = ({
  enabledCodes,
  lines,
  onChange,
}: QuoteOptionalLinesProps) => {
  const t = useTranslations("storefront.services");

  if (lines.length === 0) return null;

  return (
    <fieldset className="space-y-2">
      <legend className="text-sm font-semibold">{t("optionalLines")}</legend>
      <div className="grid gap-2 sm:grid-cols-2">
        {lines.map((line) => (
          <label
            key={line.code}
            className="border-input bg-background flex cursor-pointer items-start gap-3 rounded-md border p-3 text-sm"
          >
            <Checkbox
              className="mt-0.5"
              checked={enabledCodes.includes(line.code)}
              onCheckedChange={(checked) =>
                onChange(
                  checked
                    ? [...new Set([...enabledCodes, line.code])]
                    : enabledCodes.filter((code) => code !== line.code),
                )
              }
            />
            <span>{line.description}</span>
          </label>
        ))}
      </div>
    </fieldset>
  );
};
